<template>
    <div v-if="error.message || error.errors">
        <div class="alert is-error font-regular">
            <div class="w-full flex flex-col">
                <div class="flex items-center">
                    <div class="alert-icon">
                        <font-awesome-icon icon="exclamation" />
                    </div>

                    <span>{{ error.message }}</span>
                </div>

                <ul
                    v-if="error.errors"
                    class="list-reset mt-lg block mb-0"
                >
                    <li v-for="validationError in error.errors">
                        {{ validationError[0] }}
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            error: {
                required: false,
                type: Object,
                default: () => ({}),
            },
        },
    };
</script>